import { jsx as _jsx } from "react/jsx-runtime";
const COLOR = {
    mute: 'var(--muted-foreground)',
    onDark: 'rgba(255 255 255 / 60%)',
    line: 'var(--border-strong)',
};
export function DotSep({ tone = 'mute', style }) {
    return (_jsx("span", { style: {
            width: 3, height: 3, borderRadius: 2,
            background: COLOR[tone],
            flexShrink: 0, alignSelf: 'center',
            ...style,
        } }));
}
//# sourceMappingURL=DotSep.js.map